import {state} from '@/store/modules/Advert/state';
import {getters} from '@/store/modules/Advert/getters';
import {mutations} from '@/store/modules/Advert/mutations';
import {actions} from '@/store/modules/Advert/actions';

export default {
  state,
  getters,
  actions,
  mutations,
}
